import React from "react";
import { Link } from "react-router-dom";
import "../Style/Footer.css";

export default function Footer() {
  return (
    <footer className="mlink-footer">
      <div className="mlink-footer__bar">
        <div className="mlink-footer__top">
          <div className="mlink-footer__brand">
            <p className="mlink-footer__logo">MLink</p>
            <p className="mlink-footer__tagline">
              One link for everywhere you show up.
            </p>

            <div className="mlink-footer__social">
              <a href="#instagram" aria-label="MLink on Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
                </svg>
              </a>
              <a href="#tiktok" aria-label="MLink on TikTok">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                  <path d="M15 3c.4 2.4 2 4 4.5 4.2V10c-1.6 0-3.1-.5-4.5-1.4V15a5.5 5.5 0 1 1-4-5.3v2.7a2.8 2.8 0 1 0 2 2.7V3h2z" />
                </svg>
              </a>
              <a href="#x" aria-label="MLink on X">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                  <path d="M4 4l16 16M20 4L4 20" />
                </svg>
              </a>
            </div>
          </div>

          <nav className="mlink-footer__col">
            <p className="mlink-footer__heading">Product</p>
            <Link to="/features">Features</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/analytics">Analytics</Link>
          </nav>

          <nav className="mlink-footer__col">
            <p className="mlink-footer__heading">Company</p>
            <Link to="/about">About</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/contact">Contact</Link>
          </nav>

          <div className="mlink-footer__col mlink-footer__newsletter">
            <p className="mlink-footer__heading">Stay in the loop</p>
            <form
              className="mlink-footer__form"
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="email"
                placeholder="you@example.com"
                aria-label="Email address"
                required
              />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="mlink-footer__divider" aria-hidden="true" />

        <div className="mlink-footer__bottom">
          <p>&copy; {new Date().getFullYear()} MLink. All rights reserved.</p>
          <div className="mlink-footer__legal">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}